import React from "react";
import propTypes from "prop-types";
import {
  Button, Modal, ModalHeader, ModalBody, ModalFooter, Container,
} from "reactstrap";

const InstructionText = () => (
  <Container className="text-justify">
    <p>Please follow this steps to test your Iot device:</p>
    <ol className="pl-3">
      <li>
        Please fill the input field below with the name of
        any parameter that your Iot want to measure (e.g Elevation, Temperature, etc.)
      </li>
      <li>
        Send measurement data to the api
        {" "}
        <code>https://iotghifari.herokuapp.com/post/data?field=field_name&#38;value=value</code>
        {" "}
        with the
        {" "}
        <i>field_name</i>
        {" "}
        similar with the inputted field name before, and the
        {" "}
        <i>value</i>
        {" "}
        is the value of the field name (e.g.
        {" "}
        <code>https://iotghifari.herokuapp.com/post/data?field=Elevasi&#38;value=34</code>
        )
      </li>
      <li>If succeed, the result will be displayed at the chart as timeseries data</li>
    </ol>
  </Container>
);

const Instruction = ({ isOpen, toggle }) => (
  <Modal
    isOpen={isOpen}
    toggle={toggle}
  >
    <ModalHeader className="bg-primary text-light">
      Instruction
    </ModalHeader>
    <ModalBody>
      <InstructionText />
    </ModalBody>
    <ModalFooter>
      <Button
        color="primary"
        onClick={toggle}
      >
        Close
      </Button>
      {" "}
    </ModalFooter>
  </Modal>
);

Instruction.propTypes = {
  isOpen: propTypes.bool,
  toggle: propTypes.func.isRequired,
};

Instruction.defaultProps = {
  isOpen: false,
};

export { Instruction };
